import React from "react"
import Icon from "icons"
import {
  ModalWrapper,
  HoverContainer,
  Modal,
  CloseIconWrapper,
  CheckIcon,
  Content,
  Supertitle,
  Title,
  Description,
  SourceLink,
  ArrowIcon,
  Background,
} from "./styles"

const CitationModal = ({ citation, position, onClose }) => {
  const { nameOfPublication, description, url } = citation

  return (
    <>
      <ModalWrapper id="citation-modal">
        <HoverContainer />
        <Modal position={position}>
          <CloseIconWrapper onClick={onClose}>
            <Icon id="close-icon" width="15" height="15" fill="currentColor" />
          </CloseIconWrapper>
          <CheckIcon id="circled-check-icon" width="45" height="45" />
          <Content>
            <Supertitle>Trusted Source</Supertitle>
            <Title>{nameOfPublication}</Title>
            <Description>{description}</Description>
            <SourceLink href={url} target="_blank" rel="noreferrer">
              Go to source
              <ArrowIcon id="greater-than-icon" width="9" height="16" />
            </SourceLink>
          </Content>
        </Modal>
      </ModalWrapper>
      <Background onClick={onClose} />
    </>
  )
}

export default CitationModal
